/**
 * Validation rule level.
 */
export enum ValidationRuleLevel {
  Universal,
  Client,
  WorkOrder,
}
